<script lang="ts">
    import {OwnerDetails} from "../../models/OwnerDetails";
    import OwnerDetailsEdit from "./OwnerDetailsEdit.svelte";
    import {updateOwnerDetails} from "../../services/ApplicationDataService";

    export let ownerDetails: OwnerDetails = new OwnerDetails();
    let editMode: Boolean = false;

    const toggleOwnerDetailsEditMode = () => {
        if (editMode) {
            updateOwnerDetails(ownerDetails);
        }
        editMode = !editMode
    }
</script>

<div class="owner-details info-section">
    <div class="edit-section">
        <h2>Owner Details</h2>
<!--        TODO: Uncommented this if statement-->
<!--        {#if ownerDetails && ownerDetails.ownerType != "Same As Insured"}-->

        <!--{/if}-->
    </div>
  <hr/>
    {#if ownerDetails && ownerDetails.ownerType != undefined}
        {#if !editMode}
            {#if ownerDetails.ownerType == "1"}
                <div class="text-section">
                    <div class="text-row">
                        <div class="text-group">
                            <div class="content-text-label">Owner Type:</div>
                            <div class="bold-text">{ownerDetails.ownerTypeDisplay}</div>
                        </div>
                    </div>
                </div>
                {:else if ownerDetails.ownerType == "2"}
                    <div class="text-row">
                        <div class="text-group">
                            <div class="text-label">Owner Name:</div>
                            <div class="bold-text">{ownerDetails.personFirst || ''} {ownerDetails.personLast || ''} {ownerDetails.personSuffix || ''}</div>
                        </div>
                    </div>
                {:else if ownerDetails.ownerType == "3"}
                    <div class="text-row">
                        <div class="text-group">
                            <div class="text-label">Company Name:</div>
                            <div class="bold-text">{ownerDetails.companyName || ''} </div>
                        </div>
                    </div>

                {:else if ownerDetails.ownerType == "4"}
                    <div class="text-row">
                        <div class="text-group">
                            <div class="text-label">Trust Name:</div>
                            <div class="bold-text">{ownerDetails.trustName || ''}</div>
                        </div>
                    </div>

            {/if}
            {#if ownerDetails.ownerType == "2" || ownerDetails.ownerType == "3" || ownerDetails.ownerType == "4" }
                <div class="text-row">
                    <div class="text-group">
                        <div class="text-label">Owner Address:</div>
                        {#if ownerDetails.address}
                            <div class="bold-text">{ownerDetails.address.address1 || ''} {ownerDetails.address.address2 || ''} {ownerDetails.address.city || ''}, {ownerDetails.address.state || ''} {ownerDetails.address.zipCode || ''}</div>
                        {/if}
                    </div>
                </div>
                <div class="text-row">
                    <div class="text-group">
                        <div class="text-label">Email Address:</div>
                        <div class="bold-text">{ownerDetails.emailAddress || ''}</div>
                    </div>
                </div>

                <div class="text-row">
                    <div class="text-group">
                        <div class="text-label">Phone Number (1):</div>
                        <div class="bold-text">{ownerDetails.phoneNumber || ''}</div>
                    </div>
                </div>
            {/if}
        {/if}
    {/if}

    {#if editMode}
        <OwnerDetailsEdit ownerDetails={ownerDetails} />
        {/if}

</div>

<style lang="scss">
  @use "../../../component_scss_library/layout" as layout;
  @use "../../../component_scss_library/buttons" as buttons;
</style>
